export { WalletIcon } from './wallet'
